import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExportAttributesDto, FileTypeDto } from '@coin/importer/dto/util';
import { PopupAction } from '@coin/importer/core/util';
import { FileTypeService } from '../../services/file-type/file-type.service';
import { UploadPopupComponent } from '../upload-popup/upload-popup.component';
import { GeneralUtilities } from '../../utility/general-utilities';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'importer-export-attributes-popup',
  templateUrl: './export-attributes-popup.component.html',
  styleUrls: ['./export-attributes-popup.component.scss'],
  standalone: false
})
export class ExportAttributesPopupComponent {
  matDialogRef = inject<MatDialogRef<UploadPopupComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private fileTypeService = inject(FileTypeService);
  private toast = inject(ToastService);

  Action = PopupAction;
  item = this.data['item'] as FileTypeDto;
  action = this.data['action'] as PopupAction;
  uploading = false;
  validExportAttributes = false;
  requiredExportAttributes = false;
  originalAttributes: ExportAttributesDto[];

  constructor() {
    this.originalAttributes = GeneralUtilities.clone(this.item.exportAttributes);
  }

  close() {
    this.item.exportAttributes = [...this.originalAttributes];
    this.matDialogRef.close();
  }

  async save() {
    this.uploading = true;
    const isUpdated = await this.fileTypeService.updateFileTypeProperties(this.item);
    if (isUpdated) {
      this.close();
    } else {
      this.toast.error('could not update attributes');
    }
  }
}
